//@ts-nocheck

import React from 'react';

import IconButton from '../../components/IconButton';
import IconButton2 from '../../components/IconButton2';
import { useNavigate } from 'react-router-dom';
import { scrollTo } from '../../utils/animateScroll';
import TitleBox from '../../components/TitleBox';

const Banner = () => {
	const navigate = useNavigate();

	return (
		<div id="home" className='w-full pt-[130px] lg:pt-[260px] flex flex-col items-center px-[20px]' style={{ background: "url(/imgs/bg-grid1.png) center top" }}>
			<div className='w-full flex flex-col items-center z-10'>
				<img src="/logo.png" alt="" className="w-[100px] h-[100px]" />
				<div className='text-[32px] lg:text-[42px] text-center font-[500] lg:leading-[140px] bg-gradient-to-b from-[#FFFFFF] to-[#999999] bg-clip-text text-transparent'>
					RivalShield VPN: Privacy & Security Shield
				</div>
				<div className='text-[16px] lg:text-[20px] text-center font-[400] text-[#B3B3B3] mt-[12px] lg:mt-[20px] lg:leading-[30px] max-w-[787px] px-[10px]'>
					Welcome to RivalShield VPN, the premium mobile solution developed by Mobile Rivals to protect your digital life. In today's world, your online security is non-negotiable. RivalShield creates a secure, encrypted tunnel for your internet connection, safeguarding your personal data from hackers, especially on unsecured public Wi-Fi networks in malls, cafes, and airports.
				</div>
				<div className='mt-[47px] lg:mt-[60px] w-full flex flex-col justify-center md:flex-row gap-5'>
					<IconButton
						text='Get Your Free Quote'
						className='w-full md:w-[280px]'
						onClick={() => {
							window.open('https://play.google.com/store/apps/details?id=com.mobilerivals.rivalshield', '_blank');
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default Banner;
